import { lazy } from "react";
// project imports
import Loadable from "ui-component/Loadable";
import MinimalLayout from "layout/MinimalLayout";
import GuestGuard from "utils/route-guard/GuestGuard";

// login option 3 routing
const AuthLogin3 = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);
const AuthForgotPassword3 = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication3/ForgotPassword3")
  )
);
const VerifyOtp = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication3/VerifyOtp")
  )
);

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: (
    <GuestGuard>
      <MinimalLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: "/",
      element: <AuthLogin3 />,
    },
    {
      path: "/login",
      element: <AuthLogin3 />,
    },
    {
      path: "/forgot-password",
      element: <AuthForgotPassword3 />,
    },
    {
      path: "/verify-forget/:id",
      element: <VerifyOtp />,
    },
  ],
};

export default AuthenticationRoutes;
